var _rect, _path, _path2, _path3, _path4, _path5, _path6, _g, _mask, _path7, _path8, _path9, _path10, _path11, _mask2, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLicenseCertificate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 373,
    height: 230,
    viewBox: "0 0 373 230",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 373,
    height: 230,
    rx: 8,
    fill: "#1A1C42"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M125.608 33.0142L123.505 35.103L121.416 33L120.014 34.3925L122.103 36.4948L120 38.5836L121.392 39.9858L123.495 37.897L125.584 40L126.986 38.6075L124.897 36.5045L127 34.4164L125.608 33.0142Z",
    fill: "#E6E6E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M302.639 165.876L303.313 168.762L300.427 169.437L300.877 171.361L303.762 170.687L304.437 173.572L306.361 173.123L305.687 170.237L308.573 169.562L308.123 167.638L305.237 168.312L304.563 165.427L302.639 165.876Z",
    fill: "#E6E6E6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M192.5 174L194.091 177.232L197 179L194.091 180.768L192.5 184L190.909 180.768L188 179L190.909 177.232L192.5 174Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M75.5 92L77.0913 95.2317L80 97L77.0913 98.7683L75.5 102L73.9087 98.7683L71 97L73.9087 95.2317L75.5 92Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M75.7121 61.9389L70.7746 55.863L65.8372 49.7871L63.05 46.3571C62.8957 46.1674 63.1337 45.8713 63.2879 46.0611L68.2254 52.137L73.1628 58.2129L75.95 61.6429C76.1043 61.8326 75.8663 62.1287 75.7121 61.9389Z",
    fill: "url(#paint0_linear_968_5337)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M162.712 183.939L157.775 177.863L152.837 171.787L150.05 168.357C149.896 168.167 150.134 167.871 150.288 168.061L155.225 174.137L160.163 180.213L162.95 183.643C163.104 183.833 162.866 184.129 162.712 183.939Z",
    fill: "url(#paint1_linear_968_5337)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_968_5337)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-8-outside-1_968_5337",
    maskUnits: "userSpaceOnUse",
    x: 101,
    y: 49,
    width: 177,
    height: 112,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 101,
    y: 49,
    width: 177,
    height: 112
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101 53C101 50.7909 102.791 49 105 49H271C273.209 49 275 50.7909 275 53V157C275 159.209 273.209 161 271 161H105C102.791 161 101 159.209 101 157V53Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M101 53C101 50.7909 102.791 49 105 49H271C273.209 49 275 50.7909 275 53V157C275 159.209 273.209 161 271 161H105C102.791 161 101 159.209 101 157V53Z",
    fill: "url(#paint2_linear_968_5337)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101 49H275H101ZM275 161H101H275ZM101 161V49V161ZM271 49C274.866 49 278 52.134 278 56V154C278 157.866 274.866 161 271 161C271.552 161 272 159.209 272 157V53C272 50.7909 271.552 49 271 49Z",
    fill: "#13374F",
    mask: "url(#path-8-outside-1_968_5337)"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-10-inside-2_968_5337",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118 63.3244C118 62.0407 119.041 61 120.324 61H255.676C256.959 61 258 62.0407 258 63.3244V147.676C258 148.959 256.959 150 255.676 150H120.324C119.041 150 118 148.959 118 147.676V63.3244Z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M118 63.3244C118 62.0407 119.041 61 120.324 61H255.676C256.959 61 258 62.0407 258 63.3244V147.676C258 148.959 256.959 150 255.676 150H120.324C119.041 150 118 148.959 118 147.676V63.3244Z",
    fill: "#3FACCD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M115 63.3244C115 60.3838 117.384 58 120.324 58H252.676C255.616 58 258 60.3838 258 63.3244V64C258 64 256.959 64 255.676 64H121L115 63.3244ZM258 150H118H258ZM120.324 150C117.384 150 115 147.616 115 144.676V63.3244C115 60.3838 117.384 58 120.324 58L121 64V147.676C121 148.959 121 150 121 150H120.324ZM258 61V150V61Z",
    fill: "#1E4A68",
    mask: "url(#path-10-inside-2_968_5337)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M248 60.9941L118 144.994V64.9941C118 62.785 119.791 60.9941 122 60.9941H248Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M257 70.994L257 74.9948L143.5 149.495L137.5 149.495L257 70.994Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M129 147.494L257.5 64.9941V143.494C257.5 145.703 255.709 147.494 253.5 147.494H129Z",
    fill: "white"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-15-inside-3_968_5337",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118 63.3244C118 62.0407 119.041 61 120.324 61H255.676C256.959 61 258 62.0407 258 63.3244V147.676C258 148.959 256.959 150 255.676 150H120.324C119.041 150 118 148.959 118 147.676V63.3244Z"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M115 63.3244C115 60.3838 117.384 58 120.324 58H252.676C255.616 58 258 60.3838 258 63.3244V64C258 64 256.959 64 255.676 64H121L115 63.3244ZM258 150H118H258ZM120.324 150C117.384 150 115 147.616 115 144.676V63.3244C115 60.3838 117.384 58 120.324 58L121 64V147.676C121 148.959 121 150 121 150H120.324ZM258 61V150V61Z",
    fill: "#1E4A68",
    mask: "url(#path-15-inside-3_968_5337)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M131 102H150",
    stroke: "url(#paint3_linear_968_5337)",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M157 102H241",
    stroke: "url(#paint4_linear_968_5337)",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M131 117H222",
    stroke: "#224E6C",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M131 132H180",
    stroke: "url(#paint5_linear_968_5337)",
    strokeOpacity: 0.4,
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M187 132H241",
    stroke: "url(#paint6_linear_968_5337)",
    strokeOpacity: 0.4,
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M228 117H242",
    stroke: "#13374F",
    strokeOpacity: 0.5,
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M158.35 83.414H158.77V85.994H151.645V85.574L152.47 85.469C152.63 85.449 152.725 85.409 152.755 85.349C152.785 85.279 152.8 85.074 152.8 84.734V77.054C152.8 76.714 152.785 76.514 152.755 76.454C152.725 76.384 152.63 76.339 152.47 76.319L151.645 76.214V75.794H155.755V76.214L154.93 76.319C154.77 76.339 154.675 76.384 154.645 76.454C154.615 76.514 154.6 76.714 154.6 77.054V85.469H157.06C157.3 85.469 157.47 85.464 157.57 85.454C157.67 85.434 157.735 85.399 157.765 85.349C157.805 85.289 157.84 85.199 157.87 85.079L158.35 83.414Z",
    fill: "#1E4A68"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M160.228 76.214V75.794H164.338V76.214L163.513 76.319C163.353 76.339 163.258 76.384 163.228 76.454C163.198 76.514 163.183 76.714 163.183 77.054V84.734C163.183 85.074 163.198 85.279 163.228 85.349C163.258 85.409 163.353 85.449 163.513 85.469L164.338 85.574V85.994H160.228V85.574L161.053 85.469C161.213 85.449 161.308 85.409 161.338 85.349C161.368 85.279 161.383 85.074 161.383 84.734V77.054C161.383 76.714 161.368 76.514 161.338 76.454C161.308 76.384 161.213 76.339 161.053 76.319L160.228 76.214Z",
    fill: "#1E4A68"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M170.869 86.144C169.949 86.144 169.169 85.949 168.529 85.559C167.889 85.159 167.404 84.599 167.074 83.879C166.744 83.159 166.579 82.319 166.579 81.359V80.414C166.579 79.454 166.724 78.619 167.014 77.909C167.314 77.189 167.759 76.634 168.349 76.244C168.939 75.844 169.679 75.644 170.569 75.644C171.329 75.644 171.964 75.794 172.474 76.094C172.984 76.384 173.359 76.774 173.599 77.264C173.849 77.744 173.954 78.269 173.914 78.839L172.159 79.274C172.259 78.274 172.154 77.509 171.844 76.979C171.544 76.439 171.094 76.169 170.494 76.169C169.854 76.169 169.359 76.439 169.009 76.979C168.669 77.519 168.499 78.414 168.499 79.664V82.109C168.499 83.349 168.694 84.244 169.084 84.794C169.474 85.344 170.069 85.619 170.869 85.619C171.199 85.619 171.504 85.559 171.784 85.439C172.074 85.319 172.314 85.114 172.504 84.824C172.704 84.524 172.829 84.104 172.879 83.564L173.959 83.849C173.819 84.409 173.594 84.859 173.284 85.199C172.974 85.539 172.609 85.784 172.189 85.934C171.779 86.074 171.339 86.144 170.869 86.144Z",
    fill: "#1E4A68"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M182.789 83.414H183.209V85.994H175.784V85.574L176.609 85.469C176.769 85.449 176.864 85.409 176.894 85.349C176.924 85.279 176.939 85.074 176.939 84.734V77.054C176.939 76.714 176.924 76.514 176.894 76.454C176.864 76.384 176.769 76.339 176.609 76.319L175.784 76.214V75.794H183.059V78.374H182.639L182.159 76.709C182.129 76.589 182.094 76.504 182.054 76.454C182.024 76.394 181.959 76.359 181.859 76.349C181.759 76.329 181.589 76.319 181.349 76.319H178.739V80.579H180.449C180.689 80.579 180.859 80.574 180.959 80.564C181.059 80.544 181.124 80.509 181.154 80.459C181.194 80.399 181.229 80.309 181.259 80.189L181.589 78.974H182.009V82.709H181.589L181.259 81.494C181.229 81.374 181.194 81.289 181.154 81.239C181.124 81.179 181.059 81.144 180.959 81.134C180.859 81.114 180.689 81.104 180.449 81.104H178.739V85.469H181.499C181.739 85.469 181.909 85.464 182.009 85.454C182.109 85.434 182.174 85.399 182.204 85.349C182.244 85.289 182.279 85.199 182.309 85.079L182.789 83.414Z",
    fill: "#1E4A68"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M191.752 76.214V75.794H194.662V76.214L193.837 76.319C193.677 76.339 193.582 76.384 193.552 76.454C193.522 76.514 193.507 76.714 193.507 77.054V85.994H192.682L187.177 77.099V84.734C187.177 85.074 187.192 85.279 187.222 85.349C187.252 85.409 187.347 85.449 187.507 85.469L188.332 85.574V85.994H185.422V85.574L186.247 85.469C186.407 85.449 186.502 85.409 186.532 85.349C186.562 85.279 186.577 85.074 186.577 84.734V77.054C186.577 76.714 186.562 76.514 186.532 76.454C186.502 76.384 186.407 76.339 186.247 76.319L185.422 76.214V75.794H188.437L192.907 82.979V77.054C192.907 76.714 192.892 76.514 192.862 76.454C192.832 76.384 192.737 76.339 192.577 76.319L191.752 76.214Z",
    fill: "#1E4A68"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M199.8 85.619C200.4 85.619 200.895 85.479 201.285 85.199C201.685 84.909 201.885 84.459 201.885 83.849C201.885 83.399 201.75 83.024 201.48 82.724C201.22 82.424 200.75 82.174 200.07 81.974L198.675 81.554C197.975 81.344 197.435 80.984 197.055 80.474C196.685 79.954 196.5 79.309 196.5 78.539C196.5 78.029 196.615 77.554 196.845 77.114C197.085 76.674 197.445 76.319 197.925 76.049C198.415 75.779 199.03 75.644 199.77 75.644C200.58 75.644 201.235 75.794 201.735 76.094C202.235 76.384 202.585 76.764 202.785 77.234C202.985 77.704 203.035 78.209 202.935 78.749L201.21 79.064C201.37 78.134 201.3 77.419 201 76.919C200.71 76.419 200.235 76.169 199.575 76.169C199.065 76.169 198.655 76.319 198.345 76.619C198.045 76.919 197.895 77.349 197.895 77.909C197.895 78.369 198.025 78.774 198.285 79.124C198.555 79.474 198.995 79.744 199.605 79.934L201 80.354C201.76 80.574 202.33 80.909 202.71 81.359C203.09 81.799 203.28 82.414 203.28 83.204C203.28 83.764 203.15 84.269 202.89 84.719C202.64 85.159 202.255 85.509 201.735 85.769C201.225 86.019 200.585 86.144 199.815 86.144C199.255 86.144 198.725 86.064 198.225 85.904C197.725 85.734 197.305 85.459 196.965 85.079C196.635 84.699 196.425 84.184 196.335 83.534L197.34 83.174C197.39 83.814 197.53 84.314 197.76 84.674C198 85.024 198.295 85.269 198.645 85.409C199.005 85.549 199.39 85.619 199.8 85.619Z",
    fill: "#1E4A68"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M212.348 83.414H212.768V85.994H205.343V85.574L206.168 85.469C206.328 85.449 206.423 85.409 206.453 85.349C206.483 85.279 206.498 85.074 206.498 84.734V77.054C206.498 76.714 206.483 76.514 206.453 76.454C206.423 76.384 206.328 76.339 206.168 76.319L205.343 76.214V75.794H212.618V78.374H212.198L211.718 76.709C211.688 76.589 211.653 76.504 211.613 76.454C211.583 76.394 211.518 76.359 211.418 76.349C211.318 76.329 211.148 76.319 210.908 76.319H208.298V80.579H210.008C210.248 80.579 210.418 80.574 210.518 80.564C210.618 80.544 210.683 80.509 210.713 80.459C210.753 80.399 210.788 80.309 210.818 80.189L211.148 78.974H211.568V82.709H211.148L210.818 81.494C210.788 81.374 210.753 81.289 210.713 81.239C210.683 81.179 210.618 81.144 210.518 81.134C210.418 81.114 210.248 81.104 210.008 81.104H208.298V85.469H211.058C211.298 85.469 211.468 85.464 211.568 85.454C211.668 85.434 211.733 85.399 211.763 85.349C211.803 85.289 211.838 85.199 211.868 85.079L212.348 83.414Z",
    fill: "#1E4A68"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M214.981 76.214V75.794H219.406C220.686 75.794 221.666 76.169 222.346 76.919C223.036 77.669 223.381 78.834 223.381 80.414V81.359C223.381 82.939 223.036 84.109 222.346 84.869C221.666 85.619 220.686 85.994 219.406 85.994H214.981V85.574L215.806 85.469C215.966 85.449 216.061 85.409 216.091 85.349C216.121 85.279 216.136 85.074 216.136 84.734V77.054C216.136 76.714 216.121 76.514 216.091 76.454C216.061 76.384 215.966 76.339 215.806 76.319L214.981 76.214ZM219.331 76.319H217.936V85.469H219.331C219.841 85.469 220.251 85.384 220.561 85.214C220.871 85.034 221.096 84.704 221.236 84.224C221.386 83.734 221.461 83.029 221.461 82.109V79.664C221.461 78.744 221.386 78.044 221.236 77.564C221.096 77.084 220.871 76.759 220.561 76.589C220.251 76.409 219.841 76.319 219.331 76.319Z",
    fill: "#1E4A68"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M228 191.699L237.835 154.994L258.12 160.429L248.285 197.135L239.954 187.655L228 191.699Z",
    fill: "#9277FF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.835 154.994L228 191.699L239.954 187.655L240.328 188.081L248.433 157.834L237.835 154.994Z",
    fill: "#7158D5"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M290.119 191.699L280.284 154.994L259.999 160.429L269.835 197.135L278.165 187.655L290.119 191.699Z",
    fill: "#9277FF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M280.284 154.994L290.119 191.699L278.165 187.655L277.791 188.081L269.686 157.834L280.284 154.994Z",
    fill: "#7158D5"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M253.807 109.091C256.138 106.813 259.862 106.813 262.193 109.091L265.724 112.542C266.958 113.747 268.651 114.364 270.371 114.233L275.294 113.86C278.545 113.613 281.397 116.007 281.719 119.251L282.206 124.164C282.376 125.88 283.277 127.441 284.679 128.446L288.69 131.325C291.338 133.225 291.985 136.892 290.146 139.584L287.361 143.661C286.388 145.085 286.075 146.859 286.503 148.531L287.725 153.314C288.532 156.472 286.67 159.697 283.532 160.577L278.778 161.91C277.117 162.376 275.737 163.534 274.99 165.089L272.852 169.539C271.44 172.477 267.941 173.75 264.971 172.407L260.473 170.372C258.901 169.662 257.099 169.662 255.527 170.372L251.029 172.407C248.059 173.75 244.56 172.477 243.148 169.539L241.01 165.089C240.263 163.534 238.883 162.376 237.222 161.91L232.468 160.577C229.33 159.697 227.468 156.472 228.275 153.314L229.497 148.531C229.925 146.859 229.612 145.085 228.639 143.661L225.854 139.584C224.015 136.892 224.662 133.225 227.31 131.325L231.321 128.446C232.723 127.441 233.624 125.88 233.794 124.164L234.281 119.251C234.603 116.007 237.455 113.613 240.706 113.86L245.629 114.233C247.349 114.364 249.042 113.747 250.276 112.542L253.807 109.091Z",
    fill: "url(#paint7_linear_968_5337)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M253.807 115.091C256.138 112.813 259.862 112.813 262.193 115.091L264.114 116.968C265.347 118.173 267.04 118.79 268.761 118.659L271.438 118.456C274.688 118.21 277.541 120.603 277.862 123.847L278.127 126.519C278.297 128.235 279.198 129.796 280.6 130.801L282.781 132.367C285.429 134.267 286.076 137.934 284.237 140.626L282.723 142.843C281.75 144.267 281.437 146.041 281.864 147.713L282.529 150.314C283.336 153.472 281.474 156.697 278.336 157.577L275.751 158.302C274.09 158.768 272.709 159.926 271.962 161.481L270.8 163.901C269.388 166.839 265.889 168.112 262.919 166.769L260.473 165.662C258.901 164.952 257.099 164.952 255.527 165.662L253.081 166.769C250.111 168.112 246.612 166.839 245.2 163.901L244.038 161.481C243.291 159.926 241.91 158.768 240.249 158.302L237.664 157.577C234.526 156.697 232.664 153.472 233.471 150.314L234.136 147.713C234.563 146.041 234.25 144.267 233.277 142.843L231.763 140.626C229.924 137.934 230.571 134.267 233.219 132.367L235.4 130.801C236.802 129.796 237.703 128.235 237.873 126.519L238.138 123.847C238.459 120.603 241.312 118.21 244.562 118.456L247.239 118.659C248.96 118.79 250.653 118.173 251.886 116.968L253.807 115.091Z",
    fill: "url(#paint8_linear_968_5337)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M256.663 126.271C257.058 125.669 257.942 125.669 258.337 126.271L262.975 133.354C263.109 133.559 263.314 133.707 263.549 133.771L271.719 135.994C272.414 136.184 272.687 137.024 272.236 137.586L266.933 144.186C266.78 144.377 266.702 144.617 266.714 144.861L267.124 153.318C267.159 154.038 266.445 154.557 265.771 154.301L257.855 151.298C257.626 151.211 257.374 151.211 257.145 151.298L249.229 154.301C248.555 154.557 247.841 154.038 247.876 153.318L248.286 144.861C248.298 144.617 248.22 144.377 248.067 144.186L242.764 137.586C242.313 137.024 242.586 136.184 243.281 135.994L251.451 133.771C251.686 133.707 251.891 133.559 252.025 133.354L256.663 126.271Z",
    fill: "#FFD9AC"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M252 142.327L255.077 144.994L262 138.994",
    stroke: "#D6892C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_968_5337",
    x: 98,
    y: 46,
    width: 185,
    height: 120,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "soft-light",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_968_5337"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_968_5337",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_968_5337",
    x1: 76,
    y1: 54,
    x2: 63,
    y2: 54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_968_5337",
    x1: 163,
    y1: 176,
    x2: 150,
    y2: 176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_968_5337",
    x1: 188,
    y1: 49,
    x2: 195.563,
    y2: 217.619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F99B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2FA1B9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_968_5337",
    x1: 150,
    y1: 102,
    x2: 131,
    y2: 102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13374F",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D6388",
    stopOpacity: 0.53
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_968_5337",
    x1: 241,
    y1: 102,
    x2: 157,
    y2: 102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13374F",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D6388",
    stopOpacity: 0.53
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_968_5337",
    x1: 155.5,
    y1: 132,
    x2: 182.406,
    y2: 132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#245373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#245373",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_968_5337",
    x1: 214,
    y1: 132,
    x2: 243.652,
    y2: 132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#245373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#245373",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_968_5337",
    x1: 238,
    y1: 111.494,
    x2: 258,
    y2: 176.994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_968_5337",
    x1: 245.5,
    y1: 128.994,
    x2: 277,
    y2: 170.994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB968"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0A143"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicenseCertificate);
export default __webpack_public_path__ + "static/media/licenseCertificate.f97691121086f9d5ea9b8df63c0c0cf7.svg";
export { ForwardRef as ReactComponent };